import React, { useEffect, useState, useCallback, useMemo } from "react";
import { VariableSizeList as List } from "react-window";
import { isArray } from "underscore";
import Helper from "../../helper/Helper";
import useReduxState from "src/hooks/useReduxState";
import { useProductStore } from "src/hooks/product";
import { useProductFilterStore } from "src/hooks/productFilter";
import { Beacon } from "src/component/Global/Beacon";

const CommonFilterBoxField = ({ main_label, slug, onFacetsChange }) => {
    const [param, setParam] = useState("");
    const [listOfLI, SetListOfLI] = useState([]);
    const [{ productListWithFacet }] = useProductStore();
    const [{ filterList, filterBoxExpanded }, , { apply_product_filter, clear_product_filter }] = useProductFilterStore();
    const [firstServerCallFilter, setFirstServerCallFilter] = useReduxState(true, 'setFirstServerCallFilter');

    const processList = useCallback(() => {
        const facets = productListWithFacet?.searchFacets?.[slug]?.[slug];
        if (facets) SetListOfLI(facets);
    }, [productListWithFacet, slug]);

    useEffect(() => {
        processList();
    }, [processList]);

    const flattenCategories = useCallback((items, depth = 0, parentPath = []) => {
        let result = [];
        for (const item of items) {
            result.push({ ...item, depth, keyPath: [...parentPath, item.value] });
            if (isArray(item[slug]) && item[slug].length > 0) {
                result = result.concat(flattenCategories(item[slug], depth + 1, [...parentPath, item.value]));
            }
        }
        return result;
    }, [slug]);

    const filteredItems = useMemo(() => {
        let data = flattenCategories(listOfLI);
        if (param) {
            data = data.filter(item => item.value.toLowerCase().includes(param.toLowerCase()));
        }
        setTimeout(() => {
            if (firstServerCallFilter) {
                setFirstServerCallFilter(false)
            }
        }, 1000);
        return data;
    }, [listOfLI, param, flattenCategories]);

    const getAppliedFilterStatusByValue = useCallback((value) => {
        return filterList[slug]?.s?.find((v) => v.value === value) || false;
    }, [filterList, slug]);

    const handleClick = (item) => {
        const d = getAppliedFilterStatusByValue(item.value);
        if (!d) {
            let k = {
                key: slug,
                main_label,
                value: item.value,
            };
            if (item.Level !== undefined) {
                k.hidden_payload = { Level: item.Level };
            }
            apply_product_filter(k);
        } else {
            clear_product_filter({ key: slug, selectionIndex: d.i });
        }
        onFacetsChange({ key: slug, value: item.value });
    };

    const Row = ({ index, style }) => {
        const item = filteredItems[index];
        const paddingLeft = `${item.depth * 15}px`;
        const isActive = !!getAppliedFilterStatusByValue(item.value);
        return (
            <div style={{ ...style, paddingLeft }} key={item.value}>
                <a
                    onClick={() => handleClick(item)}
                    className={isActive ? "active" : ""}
                    style={{ cursor: "pointer", fontWeight: item.Level === 1 ? "bold" : "" }}
                >
                    {item.main_label} <span className="p-1 filter-count">({item.count})</span>
                </a>
            </div>
        );
    };
    
    const getItemSize = (index) => {
        const item = filteredItems[index];
        // Basic logic: more depth = slightly larger height (or adjust based on real content size)
        return item?.main_label?.length > 30 ? 32 : 18;
      };

    return (
        <>
            {listOfLI?.length > 0 && main_label !== "Attributes" && (
                <div className="col-auto mb-3">
                    <div className={filterBoxExpanded ? "filterbox expanded" : "filterbox"}>
                        <div className="filterbox-header position-relative">
                            {main_label === "Category" && (
                                <Beacon
                                    position={"top"}
                                    content={() => "Select a Category to view additional parametric search filters."}
                                    opener={() => <div className="becon-dot"></div>}
                                />
                            )}
                            {main_label}
                        </div>
                        <div className="product_filter_box filterbox-body">
                            <form action="" className="search-filter">
                                
                                <div className="hierarchical" style={{ maxHeight: 300, overflow:'auto' }}>
                                <div className="bs5 input-group flex-nowrap input-icon-right mt-3" id="searchText">
                                    <input
                                        name="search"
                                        id="input_categoryId"
                                        type="text"
                                        placeholder={"Search " + (main_label.toLowerCase() === "category" ? "a " : "") + main_label}
                                        onChange={(e) => {
                                            const delayDebounceFn = setTimeout(() => {
                                                setParam(e.target.value);
                                            }, 300);
                                            return () => clearTimeout(delayDebounceFn);
                                        }}
                                        autoComplete="off"
                                    />
                                    <span className="bs5 input-group-addon flex-nowrap">
                                        <span className="fa fa-search text-black-stone" />
                                    </span>
                                </div>
                                    <List
                                        height={filteredItems.length > 5000 ? 130 : filteredItems.length * 20} // display only 10 data when list morethan 5000
                                        itemCount={filteredItems.length}
                                        itemSize={getItemSize}
                                        width="100%"
                                        className="listname"
                                    >
                                        {Row}
                                    </List>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CommonFilterBoxField;
